/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
//import 'semantic-ui-css/semantic.min.css';
import './polyfills';
import App from './App';
import config from './config';
import './styles/common/fonts/gtWalsheim/gt-walsheim-bold.ttf';
import './styles/common/fonts/gtWalsheim/gt-walsheim-medium.ttf';
import './styles/common/fonts/gtWalsheim/gt-walsheim-regular.ttf';
import './index.css';
//import Layout from "./components/Layout";

ReactDOM.render(
  <Router basename={config.app.basename}>
    <App />
  </Router>,
  document.getElementById('root'),
);
